import React, { Component, PropTypes } from 'react';
import _ from 'underscore';
import FormattedAddress from '../FormattedAddress';
import { commonPropTypes } from '../../util/constants';
import ReactSelect from 'react-select';

const LocationOption = ({ location: { address, name } }) => {
  return (
    <div>
      { name ? <span><strong>{name}</strong> - </span> : null }
      <FormattedAddress address={address} componentSeparator={', '}/>
    </div>
  );
};

const renderOption = location => <LocationOption location={location}/>;

export default class LocationSearch extends Component {
  static contextTypes = {
    dao: PropTypes.object.isRequired
  };

  static propTypes = {
    value: commonPropTypes.LOCATION_SHAPE,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {};

  loadOptions = _.debounce((search, callback) => {
    const { dao } = this.context;

    dao.google.getLocations(search)
      .then(
        locations => {
          callback(
            null,
            {
              options: locations,
              complete: false
            }
          );
        }
      )
      .catch(err => callback(err.message));
  }, 250);

  handleChange = location => {
    // the react select handles backspace incorrectly for single select inputs by calling
    // onChange with an empty array - furthermore doing this when clearable is false
    const { onChange, multi, clearable } = this.props;
    if (!location || (_.isArray(location) && location.length === 0)) {
      if (clearable !== false) {
        onChange(multi ? [] : null);
      }
    } else {
      onChange(location);
    }
  };

  render() {
    const { inputClassName } = this.props;
    return (
      <ReactSelect.Async
        inputProps={{ className: inputClassName, style: { width: '100%', height: '100%', position: 'absolute' } }}
        ref="input"
        autosize={false}
        {...this.props}
        onChange={this.handleChange}
        filterOption={() => true}
        loadOptions={this.loadOptions}
        minimumInput={3}
        optionRenderer={renderOption}
        valueRenderer={renderOption}
        tabSelectsValue={false}
        valueKey="id"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/inputs/LocationSearch.jsx